import VueI18n from 'vue-i18n'
import { Component, Vue } from 'vue-property-decorator'

import { TranslatedString, getTranslatedString } from '@skinsoft/types'

declare const FALLBACK_LOCALE

@Component({
    props: {
        tag: {
            required: false,
            type: String,
        },
        value: [Number, String, Object],
        values: {
            required: false,
            type: [Array, Object],
        },
        dataCy: {
            required: false,
            type: String
        }
    },
})
export class LocalizedString extends Vue {
    public tag: string;
    public value: string | TranslatedString;
    public values: any[] | Record<string, any>;
    public dataCy: String

    public $i18n: VueI18n;

    public render(createElement) {
        let message = "";
        // Value is a translation key, looking in locales.ts
        if (typeof this.value === "string") {
            message = this.$te(this.value, this.$i18n.locale) ?
                this.$t(this.value, this.values) as string : this.value;
        }
        // Value is a translated string, unmarshalling it with current locale
        else {
            message = getTranslatedString(this.value, this.$i18n.locale, FALLBACK_LOCALE)
        }

        return createElement(
            this.tag || 'span', 
            {
                on: {
                    click: (event) => this.$emit('click', event)
                },
                attrs: {
                    'data-cy': this.dataCy
                },
            }, 
            message
        )
    }
}
